<script setup lang="ts">
import type { ContentBlockProps } from '.';

import { cn } from '@/utils';
import { Primitive } from 'reka-ui';

import { blockVariant, contentVariant, titleVariant } from '.';

const props = withDefaults(defineProps<ContentBlockProps>(), {
	as: 'section',
	titleAs: 'h4'
});
</script>

<template>
	<Primitive
		:as="as"
		:as-child="asChild"
		:class="cn(blockVariant({ variant }), props.class)"
	>
		<slot name="title" :classes="titleVariant({ variant })">
			<Primitive
				v-if="title"
				:as="titleAs"
				:as-child="false"
				:class="cn(titleVariant({ variant }), props.titleClass)"
			>
				{{ title }}
			</Primitive>
		</slot>
		<div :class="cn(contentVariant({ variant }), props.contentClass)">
			<slot />
		</div>
	</Primitive>
</template>
